import { genreOptions, regionOptions, decadeOptions } from "@/mocks/movies";

export type SortKey = "latest" | "rating" | "popular";

type FilterBarProps = {
  genre: string;
  region: string;
  decade: string;
  sort: SortKey;
  onGenre: (v: string) => void;
  onRegion: (v: string) => void;
  onDecade: (v: string) => void;
  onSort: (v: SortKey) => void;
  onClear: () => void;
};

const sortOptions: { key: SortKey; label: string }[] = [
  { key: "popular", label: "热门程度" },
  { key: "latest", label: "上映时间" },
  { key: "rating", label: "评分高低" },
];

function Chip({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-800 text-foreground-300 hover:bg-background-700"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterBar({
  genre,
  region,
  decade,
  sort,
  onGenre,
  onRegion,
  onDecade,
  onSort,
  onClear,
}: FilterBarProps) {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs text-foreground-500 mb-3 font-label tracking-wide">影片类型</p>
        <div className="flex flex-wrap gap-2">
          <Chip active={!genre} label="全部" onClick={() => onGenre("")} />
          {genreOptions.map((g) => (
            <Chip key={g} active={genre === g} label={g} onClick={() => onGenre(g)} />
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs text-foreground-500 mb-3 font-label tracking-wide">上映年代</p>
        <div className="flex flex-wrap gap-2">
          <Chip active={!decade} label="全部" onClick={() => onDecade("")} />
          {decadeOptions.map((d) => (
            <Chip key={d} active={decade === d} label={d} onClick={() => onDecade(d)} />
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs text-foreground-500 mb-3 font-label tracking-wide">制片地区</p>
        <div className="flex flex-wrap gap-2">
          <Chip active={!region} label="全部" onClick={() => onRegion("")} />
          {regionOptions.map((r) => (
            <Chip key={r} active={region === r} label={r} onClick={() => onRegion(r)} />
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs text-foreground-500 mb-3 font-label tracking-wide">排序方式</p>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((s) => (
            <Chip key={s.key} active={sort === s.key} label={s.label} onClick={() => onSort(s.key)} />
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onClear}
        className="inline-flex items-center gap-1.5 text-xs text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
      >
        <i className="ri-refresh-line"></i> 清除全部筛选
      </button>
    </div>
  );
}